export class Parametro {
  IdParametro: number;
  Nombre: string;
  IdGrupo: number;
  Abreviatura: string;
  Valor1: string;
  Valor2: string;
  Activo: number;
}


